var React = require('react');

function GolfClub (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M64 205.15a64 64 0 0 0-64 64v26.9h120a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H0v48h120a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H0v8a64.06 64.06 0 0 0 64 64h302.6a64 64 0 0 0 57.7-36.26l90-187.42-438.5-82.12a64 64 0 0 0-11.8-1.1z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M120 392.05H0v48h120a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm0-96H0v48h120a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zM631 8.59l-14.4-6.94-.18-.09a15.91 15.91 0 0 0-21.22 7.49L465.55 279.24l48.76 9.13L638.4 30A16.14 16.14 0 0 0 631 8.59z","className":"fa-primary","key":2})]);
}

GolfClub.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = GolfClub;

GolfClub.default = GolfClub;
